import fetchApi from 'utils/api-utils';
import type { GarageLocation } from 'ts/types/destination.types';
import type { ApiResponse } from 'ts/interfaces/api-response.interface';
import { getProps } from 'utils/global-utils';

const SYNERGY_CREATE_QUESTION_URL =
  process.env.REACT_APP_SYNERGY_CREATE_QUESTION_URL;

export type CreateQuestionBody = {
  preferred_touch_point: 'VOI_PHONE' | 'E-MAIL' | 'SMS';
  service_context: {
    questions_and_answers?: any[];
    pickup_location: Partial<GarageLocation> | undefined;
    destination: Partial<GarageLocation> | undefined;
  };
};

export type CreateQuestionParams = {
  body: CreateQuestionBody;
  token: string;
  partner: string;
  provider: string;
  tenantId: string;
};

type CreateQuestion = (
  params: CreateQuestionParams,
) => Promise<ApiResponse<any>>;

export const createQuestion: CreateQuestion = async ({
  body,
  token,
  tenantId,
  provider,
  partner,
}) => {
  const rs = await fetchApi(SYNERGY_CREATE_QUESTION_URL, {
    method: 'POST',
    body,
    headers: {
      'content-type': 'application/json; charset=utf-8',
      'x-env': process.env.REACT_APP_ABODE_ENV,
      'x-token': token,
      'x-tenant-id': tenantId,
      'x-provider': provider,
      'x-partner': partner,
      'x-requested-by': 'synergy',
    },
  });
  const data = getProps(rs, 'json') && (await rs.json());
  return { status: rs.status, ok: rs.ok, result: data };
};

export default createQuestion;
